import React from 'react';
import { Box, Typography, SvgIcon, Menu, MenuItem } from '@mui/material';
import { LinearProgress } from '@mui/material';
import { IconButtonWrapper } from 'sharedComponents/UI';
import { DotsHorizontal } from 'components/SVG';
import { Upload, CreateIcon, VisibilityIcon } from 'components/SVG';
import { SPARK_ROUTES } from 'constants/routes';

type SparkOptionsKnowledgeModalProps = {
  showProgressBar: boolean;
  percentageComplete: number;
  row: {
    memoryID?: string;
    categoryID?: string;
    sparkID?: string;
  };
  handleUploadMemoryModal: (row: any, categoryID?: string) => void;
  handleCreateClick: (row: any) => void;
  navigate: (path: string) => void;
  isMobile: boolean;
};

const SparkOptionsKnowledgeModal: React.FC<SparkOptionsKnowledgeModalProps> = ({
  showProgressBar,
  percentageComplete,
  row,
  handleUploadMemoryModal,
  handleCreateClick,
  navigate,
  isMobile,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      display='flex'
      gap={2}
      alignItems='flex-end'
      flexDirection={isMobile ? 'column' : 'row'}
      justifyContent='flex-end'
      width='100%'
    >
      {showProgressBar ? (
        <Box sx={{ width: '60%', height: '8px' }}>
          <LinearProgress
            sx={{ height: '8px', borderRadius: '10px' }}
            variant='determinate'
            value={percentageComplete}
          />
        </Box>
      ) : (
        <>
          <IconButtonWrapper
            onClick={handleMenuOpen}
            sx={{ margin: 0, cursor: 'pointer' }}
          >
            <DotsHorizontal />
          </IconButtonWrapper>
          <Menu anchorEl={anchorEl} open={isMenuOpen} onClose={handleMenuClose}>
            {row.memoryID ? (
              <MenuItem
                onClick={() => {
                  navigate(`${SPARK_ROUTES.MEMORY}/${row.memoryID}`);
                  handleMenuClose();
                }}
              >
                <SvgIcon
                  sx={{
                    '& path': {
                      fill: 'theme.primary.main',
                    },
                    stroke: 'theme.primary.main',
                    marginRight: 1,
                  }}
                >
                  <VisibilityIcon width='24px' height='24px' color='#6267AC' />
                </SvgIcon>
                <Typography variant='body1'>View</Typography>
              </MenuItem>
            ) : (
              <>
                <MenuItem
                  onClick={() => {
                    handleUploadMemoryModal(row, row.categoryID);
                    handleMenuClose();
                  }}
                >
                  <SvgIcon
                    sx={{
                      '& path': {
                        fill: 'theme.primary.main',
                      },
                      stroke: 'theme.primary.main',
                      marginRight: 1,
                    }}
                  >
                    <Upload width='24px' height='24px' color='#6267AC' />
                  </SvgIcon>
                  <Typography variant='body1'>Upload</Typography>
                </MenuItem>
                {row.sparkID && (
                  <MenuItem
                    onClick={() => {
                      handleCreateClick(row);
                      handleMenuClose();
                    }}
                  >
                    <SvgIcon
                      sx={{
                        '& path': {
                          fill: (theme) => theme.palette.primary.light,
                          stroke: (theme) => theme.palette.primary.main,
                        },
                        marginRight: 1,
                      }}
                    >
                      <CreateIcon
                        width='25.36px'
                        height='24px'
                        color='purple'
                      />
                    </SvgIcon>
                    <Typography variant='body1'>Create</Typography>
                  </MenuItem>
                )}
              </>
            )}
          </Menu>
        </>
      )}
    </Box>
  );
};

export default SparkOptionsKnowledgeModal;
